import { createSelector } from 'reselect';

const userStateSelector = state => state.ustate;

export default createSelector(userStateSelector,
	(ustate) => {
		return {
			ustate: ustate
		};
	}
);


// WEBPACK FOOTER //
// ./src/selectors/ustateSelector.js